import React from 'react';
import { Scan, Brain, HeartPulse, Activity } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { mockServices } from '../mock';

const iconMap = {
  scan: Scan,
  brain: Brain,
  'heart-pulse': HeartPulse,
  activity: Activity
};

export const ServicesSection = () => {
  return (
    <section id="services" className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-50">
      <div className="container mx-auto">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-teal-600 font-semibold text-sm uppercase tracking-wide">Our Services</span>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-3 mb-4">
            Premium Medical Equipment Solutions
          </h2>
          <p className="text-lg text-slate-600">
            We provide certified refurbished medical imaging equipment with comprehensive service and support packages.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {mockServices.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="border-slate-200 hover:border-teal-300 hover:shadow-xl transition-all duration-300 group"
              >
                <CardHeader>
                  <div className="w-14 h-14 bg-teal-50 rounded-xl flex items-center justify-center mb-4 group-hover:bg-teal-100 transition-colors">
                    <IconComponent className="text-teal-600" size={28} />
                  </div>
                  <CardTitle className="text-xl text-slate-900">{service.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-slate-600 leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Additional Info */}
        <div className="mt-12 text-center">
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-slate-200 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-slate-900 mb-4">Complete Service Package Included</h3>
            <p className="text-slate-600 mb-6">
              Every equipment purchase comes with installation, training, warranty, and ongoing maintenance support.
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-sm">
              <span className="bg-teal-50 text-teal-700 px-4 py-2 rounded-full font-medium">Installation</span>
              <span className="bg-teal-50 text-teal-700 px-4 py-2 rounded-full font-medium">Training</span>
              <span className="bg-teal-50 text-teal-700 px-4 py-2 rounded-full font-medium">Warranty</span>
              <span className="bg-teal-50 text-teal-700 px-4 py-2 rounded-full font-medium">Maintenance</span>
              <span className="bg-teal-50 text-teal-700 px-4 py-2 rounded-full font-medium">24/7 Support</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};